// extracted by mini-css-extract-plugin
module.exports = {"badge":"FacetBadgeLabel_badge__wtSxL","dark":"FacetBadgeLabel_dark__PxSJH"};